import { NodeId } from '@candulabs/craft';

import { useMultiCssSelector } from 'craft/hooks/useMultiCssSelector';
import { useMultiNodes } from 'craft/hooks/useMultiNodes';
import { CssSelectorId } from 'craft/types';

export const useRootCss = (
  nodeIds: NodeId[],
  commonProperty?: any,
  cssSelectorId: CssSelectorId = CssSelectorId.Root,
) => {
  const {
    css: plainCss,
    actions: { setCss: setPlainCss },
  } = useMultiNodes(nodeIds, (node) => ({ css: node?.data?.custom?.css ?? {} }), commonProperty);
  const { css: baseCss, setCssSelector: setBaseCss } = useMultiCssSelector(
    nodeIds,
    cssSelectorId,
    commonProperty,
  );

  // for the time being, if you're setting the root css we're just setting the regular css object
  // instead of using a css selector.
  // this is just to avoid migrations as some objects and parts of the code base still rely on this object, for examle the Modal and Document components.
  if (cssSelectorId === CssSelectorId.Root) {
    return { css: plainCss, setCss: setPlainCss };
  }
  return { css: baseCss, setCss: setBaseCss };
};
